import { gql } from '@apollo/client';

export const GET_PUBLISHED_TEMPLATE = gql`
  query publishedCashflowTemplate($countryIsoCodes: [String!], $modelType: String!) {
    publishedCashflowTemplate(countryIsoCodes: $countryIsoCodes, modelType: $modelType) {
      id
      modelType
      s3Bucket
      s3Key
      isPublished
      country {
        id
        displayName
      }
    }
  }
`;

export const CREATE_CASHFLOW_TEMPLATE = gql`
  mutation createCashflowTemplate($input: CreateCashflowTemplateInput!) {
    createCashflowTemplate(input: $input) {
      templates {
        id
        name
        description
        modelType
        s3Bucket
        s3Key
        isPublished
        createdAt
        updatedAt
        publishedAt
        country {
          id
          displayName
        }
        createdBy {
          id
          firstName
          lastName
        }
        publishedBy {
          id
          firstName
          lastName
        }
      }
      errors
    }
  }
`;

export const CREATE_PRESIGNED_S3_URL = gql`
  mutation createPresignedS3Url($modelType: String!) {
    createPresignedS3Url(modelType: $modelType) {
      uuid
      s3Key
      s3Bucket
      signedUrl {
        url
        fields
      }
      errors
    }
  }
`;

export const PUBLISH_CASHFLOW_TEMPLATE = gql`
  mutation publishCashflowTemplate($id: ID!) {
    publishCashflowTemplate(id: $id) {
      template {
        id
        modelType
        s3Bucket
        s3Key
        isPublished
        createdAt
        country {
          id
          displayName
        }
        createdBy {
          id
          firstName
          lastName
        }
        publishedBy {
          id
          firstName
          lastName
        }
      }
      errors
    }
  }
`;
